import React, { useState, useRef, useEffect } from 'react';
import { Keyboard } from 'lucide-react';

const SHORTCUTS = [
  { label: 'Symbol Search', keys: ['Alt', 'S'] },
  { label: 'Timeframes (1m-1d)', keys: ['Alt', '1-7'] },
  { label: 'Trendline', keys: ['Alt', 'T'] },
  { label: 'Horizontal Line', keys: ['Alt', 'H'] },
  { label: 'Measure Tool', keys: ['Alt', 'M'] },
  { label: 'Clear all drawings', keys: ['Alt', 'C'] },
];

const ShortcutReference = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div ref={dropdownRef} style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <button 
        className="toolbar-dropdown-btn" 
        onClick={() => setIsOpen(!isOpen)}
        title="Keyboard Shortcuts"
      >
        <Keyboard size={16} />
        <span>Shortcuts</span>
      </button>

      {isOpen && (
        <div className="shortcut-dropdown-menu">
          <div className="shortcut-header">Keyboard Shortcuts</div>
          <div className="shortcut-list">
            {SHORTCUTS.map((sc, idx) => (
              <div key={idx} className="shortcut-row">
                <span className="shortcut-label">{sc.label}</span>
                <div className="shortcut-keys">
                  {sc.keys.map((k, i) => (
                    <React.Fragment key={i}>
                      <span className="key-badge">{k}</span>
                      {i < sc.keys.length - 1 && <span className="key-plus">+</span>}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShortcutReference;
